import { Campaign, MediaMention } from "../types";

export const metrics = [
  { value: "1.4M+", label: "books sold through represented campaigns" },
  { value: "7+", label: "years of PR and author marketing experience" },
  { value: "5", label: "core publicity channels for complete launch support" },
  { value: "Weekly", label: "campaign updates with clear next steps" },
];

export const campaigns: Campaign[] = [
  { name: "Literary fiction launch", stage: "Media outreach live", score: 92, outlets: "86", owner: "Nia" },
  { name: "Memoir interview tour", stage: "Podcast booking", score: 88, outlets: "42", owner: "Marco" },
  { name: "Children's book visibility", stage: "Book club review", score: 81, outlets: "38", owner: "Asha" },
  { name: "Premium billboard launch", stage: "Creative approved", score: 95, outlets: "24", owner: "Theo" },
];

export const mentions: MediaMention[] = [
  { source: "Literary Review Weekly", headline: "New author campaign earns early attention from regional reviewers", sentiment: "Positive", reach: "240K" },
  { source: "Book Club Brief", headline: "Readers respond to guided discussion kit and author Q&A format", sentiment: "Positive", reach: "96K" },
  { source: "Podcast Shelf", headline: "Debut novelist explains the personal story behind a breakout release", sentiment: "Positive", reach: "74K" },
];

export const journalists = [
  { name: "Elena Park", beat: "Literary fiction", outlet: "The Reader Ledger", fit: "98% fit" },
  { name: "Ravi Menon", beat: "Publishing and culture", outlet: "Arts Current", fit: "94% fit" },
  { name: "Claire Booth", beat: "Children's books", outlet: "Family Reads", fit: "91% fit" },
];
